module.exports = __webpack_public_path__ + "static/img/process-26.29daadd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/process-26.jpg
// module id = tzNh
// module chunks = 0